/**
 * @file AG-Grid module registration — modular enterprise imports.
 *
 * Registers only the enterprise modules needed by A3S.
 * Import this file once at app startup (before any grid renders).
 */
import { ModuleRegistry, AllCommunityModule } from "ag-grid-community";
import { RowGroupingModule, SetFilterModule, ExcelExportModule } from "@amzn/gft-ag-grid-enterprise";

ModuleRegistry.registerModules([AllCommunityModule, RowGroupingModule, SetFilterModule, ExcelExportModule]);
